// language=GLSL
export const glslConstants = `
#ifndef GLSL_CONSTANTS
#define GLSL_CONSTANTS
const float PI = 3.1415926535897932384626433832795;
const float ETA = .5 * PI;
const float TAU = 2. * PI;
#endif
`;